import { ErrorContext } from '@leagueplatform/observability';
import { SocketAsFetch } from '@leagueplatform/socket-as-fetch';

export const getContainerPDF = async (
  messageType: string,
  params: { [x: string]: string | number },
  errorContext?: ErrorContext,
) =>
  SocketAsFetch.fetch(
    {
      message_type: messageType,
      info: {
        ...params,
      },
    },
    {
      errorContext,
    },
  );
